import styled from "styled-components";
import { COLORS, LEVELS } from "styles/colors";
import { FLEX } from "styles/flex";
import { ModalRadioItem } from "styles/ModalRadioCommonStyled";
import { calcRem } from "styles/theme";

export const ModalTitle = styled.div`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 6px;
  width: 100%;

  .sub {
    font-weight: normal;
    font-size: ${calcRem(15)};
    line-height: 1;
    color: ${({ theme }) => theme.COLORS.WHITE}70;
  }
  .account-id-label {
    font-size: ${calcRem(14)};
  }
`;

export const AccessList = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 16px;
`;

export const AccessItem = styled(ModalRadioItem)`
  padding: 20px;
  ${FLEX.FlexStartStart};

  .report-item-title {
    ${FLEX.FlexBetweenCenter};
    padding-bottom: 4px;
  }

  .radio-wrapper {
    ${FLEX.FlexEndCenter};
    gap: 8px;
  }
  .label {
    padding: 4px 8px;
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE}70;
    border-radius: 2px;
    font-size: ${calcRem(12)};
    line-height: 1;
  }

  .unvailable-label {
    background-color: ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
  }
  .temporary-label {
    background-color: ${({ theme }) => theme.COLORS.SELECTED};
    color: ${COLORS.WHITE};
  }

  .temporary-requset-info {
    color: ${({ theme }) => theme.COLORS.SELECTED};
    font-weight: 500;
  }

  .temporary-button-wrapper {
    ${FLEX.FlexBetweenStart};
    gap: 10px;
    padding-top: 16px;

    > div {
      ${FLEX.FlexStartStart};
      flex-direction: column;
      gap: 4px;

      &:first-child {
        flex: 2;
      }
      &:last-child {
        flex: 1;
      }
    }
  }
`;
